export const MAX_MODAL_WIDTH = 760 as const;
export const MARGIN_FROM_EDGE = 24 as const;
